import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PromotionList } from "../../entities/promotionlist.model";
import { PromotionType } from "../../../crossconcern/types/promotion.type";
import { ProductUUIDType } from "../../../crossconcern/types/productuuid.type";
import { PromotionModel } from "../../entities/promotion.model";
import { NurseryUUIDType } from "app/crossconcern/types/nurseryuuid";
import { MediaList } from "../../entities/medialist.model";

@Injectable()
export abstract class PromotionRepositoryInterface {
    public abstract getPromotions(
        pageSize: number,
        page: number,
        nurseryUuid: string,
        featured: boolean): Observable<PromotionList>

    public abstract getPromotion(uuid: string): Observable<PromotionModel>
    public abstract getPromotionMedia(uuid: string): Observable<MediaList>
    public abstract addPromotion(promotionType: PromotionType, productUUIDType: ProductUUIDType,
        nurseryUUIDType: NurseryUUIDType): Observable<PromotionModel>

    public abstract addPromotionImage(body: FormData, promotionUUID: string): Observable<{}>;

    public abstract deletePromotion(uuid: string): Observable<{}>
    public abstract updatePromotion(uuid: string, promotionType: PromotionType): Observable<PromotionModel>

    public abstract addPromotionProducts(uuid: string, productUUIDType: ProductUUIDType): Observable<{}>
    public abstract deletePromotionProducts(uuid: string, productUUIDType: ProductUUIDType): Observable<{}>

    public abstract addPromotionNurseries(uuid: string, nurseryUUIDType: NurseryUUIDType): Observable<{}>
    public abstract deletePromotionNurseries(uuid: string, nurseryUUIDType: NurseryUUIDType): Observable<{}>
}